import * as _draftJsCheckableListItem from 'draft-js-checkable-list-item';
import _draftJs from 'draft-js';

('use strict');
Object.defineProperty(exports, '__esModule', {
  value: true,
});
var adjustBlockDepth = function adjustBlockDepth(editorState, ev) {
  var newEditorState = _draftJsCheckableListItem.CheckableListItemUtils.onTab(ev, editorState, 4);
  if (newEditorState !== editorState) {
    return newEditorState;
  }
  return _draftJs.RichUtils.onTab(ev, editorState, 4);
};
var _default = adjustBlockDepth;
export default _default;
